import { Discount } from '../../types/DiscountTypes'
import { CalculateDiscountLogic, Calculation, CalculationUserInput, DiscountType } from './CalculateDiscountTypes'

export class ZeroDiscountLogic implements CalculateDiscountLogic {
  type: DiscountType = 'none'
  discountDefinition: Discount

  constructor() {
    this.discountDefinition = {
      id: 'none',
      type: 'none',
      name: 'No Discount',
      value: 0,
      calculationType: 'amount',
      appliesTo: 'allParticipants',
      canBeCombined: true
    }
  }

  chooseEligible(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    return []
  }

  calculate(previousCalculations: Calculation[], userInput: CalculationUserInput) {
    return previousCalculations
  }
}
